var map = {
	"./accordions/accordions.js": 5799,
	"./ajax/popup-modules/give-rating/give-rating.js": 2620,
	"./ajax/popup.js": 1862,
	"./ajax/popups.js": 9311,
	"./article-link/article-link.js": 4413,
	"./card-hover-slider/card-hover-slider.js": 7761,
	"./card-labels/card-labels.js": 3101,
	"./countdown/countdown.js": 1884,
	"./expanded-menu/expanded-menu.js": 1070,
	"./footer-menu/footer-menu.js": 6567,
	"./glossary-tooltip/glossary-tooltip.js": 4126,
	"./instruction-block/instruction-block.js": 195,
	"./interactive-map/interactive-map.js": 3843,
	"./labels/labels.js": 3867,
	"./payment-labels/payment-labels.js": 4476,
	"./product-info-cards/product-info-cards.js": 5098,
	"./sections/additional-products/additional-products.js": 1068,
	"./sections/articles-other/articles-other.js": 9521,
	"./sections/articles/articles.js": 8167,
	"./sections/benefits-hover/benefits-hover.js": 5165,
	"./sections/benefits-thumbs/beneftis-thumbs.js": 6296,
	"./sections/benefits/benefits.js": 4833,
	"./sections/catalog-sorting/catalog-sorting.js": 9420,
	"./sections/catalog-sorting/change-layout/change-layout.js": 6172,
	"./sections/catalog-tags/catalog-tags.js": 8580,
	"./sections/categories/categories.js": 4137,
	"./sections/characteristics/characteristics.js": 2963,
	"./sections/collections-thumbs/collections-thumbs.js": 6289,
	"./sections/comparison/compare-filter/compare-filter.js": 3635,
	"./sections/comparison/compare-table/compare-table.js": 9852,
	"./sections/comparison/comparison.js": 4133,
	"./sections/comparison/js/sliders-options.js": 3847,
	"./sections/comparison/js/slides-counter.js": 7271,
	"./sections/events/events.js": 9779,
	"./sections/filter/blocks/filter-colors/filter-colors.js": 443,
	"./sections/filter/filter.js": 5149,
	"./sections/glossary/glossary-block/glossary-block.js": 6915,
	"./sections/header/blocks/dropdown-menu/dropdown-menu.js": 3761,
	"./sections/header/blocks/dropdown-menu/js/dropdown-menu-core.js": 3621,
	"./sections/header/blocks/dropdown-menu/js/move-icons.js": 2631,
	"./sections/header/blocks/dropdown-menu/js/switchable-menu.js": 8704,
	"./sections/header/blocks/header-search/header-search.js": 9409,
	"./sections/header/header.js": 6256,
	"./sections/header/js/header-hamburger.js": 5952,
	"./sections/included-article/included-article.js": 535,
	"./sections/kit/kit.js": 3239,
	"./sections/map-site/elems/__block/__block.js": 299,
	"./sections/new-products/new-products.js": 7831,
	"./sections/order-fieldset/order-fieldset.js": 6571,
	"./sections/product-description/product-description.js": 9126,
	"./sections/product-page-card/product-page-card.js": 3310,
	"./sections/resently-viewed/resently-viewed.js": 2345,
	"./sections/reviews/slider/reviews-slider.js": 7449,
	"./sections/search/search.js": 3603,
	"./sections/selection/selection.js": 5499,
	"./sections/sidebar-accessories/sidebar-accessories.js": 491,
	"./sections/sidebar-additional/sidebar-additional.js": 7752,
	"./sections/sidebar-helpful/sidebar-helpful.js": 9598,
	"./sections/slider-main/slider-main.js": 8711,
	"./sections/text-inner/text-inner.js": 8014,
	"./sections/text-inners-form/elems/__file/__file.js": 6991,
	"./sections/video-reviews/video-reviews.js": 2169,
	"./sections/videos-about-product/videos-about-product.js": 9485,
	"./simple-popup/simple-popup.js": 4348,
	"./submenu/submenu.js": 2943,
	"./tags/tags.js": 814,
	"./tooltip/tooltip.js": 6692,
	"./up-button/up-button.js": 3758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5775;